import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { IconPhotograph } from '@at/design-system-icons';
import { StyledAdvertImage, StyledImageNotAvailable, StyledImageNotAvailableText } from './advert-image.styled';
import { Usage } from './advert-image.types';
import { generateDimensionsFromUsage, generateSrcFromUsage, generateSrcSetFromUsage } from './advert-image.utils';
export var AdvertImageNotAvailable = function (_a) {
    var usage = _a.usage;
    var isThumbnail = usage === Usage.Thumbnail;
    return (React.createElement(StyledImageNotAvailable, null,
        React.createElement(IconPhotograph, { title: "" }),
        React.createElement(StyledImageNotAvailableText, { isThumbnail: isThumbnail }, "Image not available")));
};
export var AdvertImage = function (_a) {
    var src = _a.src, usage = _a.usage, pageBreakpoints = _a.pageBreakpoints, onError = _a.onError, rest = __rest(_a, ["src", "usage", "pageBreakpoints", "onError"]);
    var _b = useState(false), loadError = _b[0], setLoadError = _b[1];
    if (loadError) {
        return React.createElement(AdvertImageNotAvailable, { usage: usage });
    }
    var _c = generateDimensionsFromUsage(usage), generatedWidth = _c.width, generatedHeight = _c.height;
    var generatedSrc = generateSrcFromUsage(src, usage);
    var generatedSrcSet = generateSrcSetFromUsage(src, usage, pageBreakpoints);
    return (React.createElement(StyledAdvertImage, { src: generatedSrc,
        srcSet: generatedSrcSet,
        imageAttributes: __assign(__assign({}, rest), { width: generatedWidth, height: generatedHeight, loading: rest.loading || 'lazy', decoding: rest.decoding || 'async', style: {
                visibility: 'hidden',
            }, onLoad: function (event) {
                event.currentTarget.style.visibility = 'visible';
            }, onError: function (event) {
                setLoadError(true);
                if (onError) {
                    onError(event);
                }
            } }) }));
};
